import React from "react";
import InlineLink from "../components/InlineLink";

const MakeGames = () => {
  return (
    <div>
      <h4>Are You Beginner Developer? - Why you should make games</h4>
      <p>
        So I have been making a board game, called
        <InlineLink
          text={"Peg Solitaire"}
          url="https://en.wikipedia.org/wiki/Peg_solitaire"
        />
        . It's a simple board game. There were plenty of lessons learned along
        the way.
      </p>
      <p>
        So, I want to talk to you about a concept that's near and dear to my
        heart: gamifying technology. As a developer, I've found that one of the
        most effective ways to learn the basics and limitations of any system is
        by making a game out of it.
      </p>
      <p>
        Now, I know what you're thinking. "A game? But I'm a serious developer,
        not a gamer!" Hear me out, Gamification isn't just about turning
        everything into a flashy, button-mashing spectacle. It's about
        harnessing the power of play to engage with complex concepts in a fun
        and interactive way.
      </p>
      <p>
        Most of the modern development libraries/environments are optimized for
        a general purpose. Like React has optimized for forms, and in-general
        reactive CSR-based frontends. While making forms in React has been
        handled beautifully by some libraries such as Formik, reach-hook-form,
        you don't really get to learn the taps and knobs of React using it.
      </p>
      <p>
        This is where games come in, while developing games, every decision is
        crucial. Your choice of data structures, algorithms and how you use the
        fundamental features of the framework are tested. The amount of
        architectural challenges faced by you while developing a game is much
        higher than making some generic app out of the same library/framework.
      </p>
    </div>
  );
};

export default MakeGames;
